import { css } from 'linaria';
import { styled } from 'linaria/react';

export const GalleryGrid = styled.div`
  display: grid;
  grid-auto-flow: dense;
  grid-gap: 24px;
  grid-template-columns: repeat(2, 1fr);

  @media (--only-tablet) {
    grid-column-gap: unset;
    grid-template-columns: 1fr;
  }

  @media (--only-mobile) {
    grid-column-gap: unset;
    grid-template-columns: 1fr;
    row-gap: 16px;
  }
`;

export const GalleryImageWrapper = styled.div`
  position: relative;
  height: 380px;
  padding: 0;
  font-family: inherit;
  border: none;
  border-radius: var(--rounding-l);
  cursor: pointer;

  @media (--only-mobile) {
    height: 216px;
  }
`;

export const galleryImageDefaultWrapper = css`
  &:nth-of-type(10n - 6) {
    grid-column-start: 1;
  }

  &:nth-of-type(10n -5),
  &:nth-of-type(10n -2) {
    height: 784px;

    @media (--from-tablet) {
      grid-row-start: span 2;
    }

    @media (--only-mobile) {
      height: 376px;
    }
  }
`;

export const galleryImage = css`
  width: 100%;
  height: 100%;
  margin: 0;
  border-radius: var(--rounding-l);
  object-fit: cover;
`;

export const showMoreBtnWrapper = css`
  display: flex;
  justify-content: center;
  width: 100%;
  margin-top: 32px;
`;
